import _ from 'lodash';
import { dateRenderer } from '../../services/formatSvc';
import { status_ru, state_ru } from '../../helpers/buy';
import { getLookupObject } from '../../utils/table';

export const mapBuys = (buys) => buys.map((b) => ({
  ...b,
  projName: `${b.proj.fullNumber} ${b.proj.name}`,
  protocolNum: b.approvalNum ? `№${b.approvalNum} от ${dateRenderer(b.approvalDate)}` : '',
  assessedValue: b.status === 'approved' && !b.state ? b.approvedSum : b.draftSum,
}));

export const getFilterLookups = (mappedBuys) => ({
  projects: getLookupObject(mappedBuys, 'projName'),
  names: getLookupObject(mappedBuys, 'name'),
  protocolNums: getLookupObject(mappedBuys, 'protocolNum'),
  version: getLookupObject(mappedBuys, 'version'),
  status: status_ru,
  state: state_ru,
});
